import { OVERLAY_PREF } from "src/generator/constants";

export const getOverlayTargetId = (uuid: string, targetId?: string) => {
  if (!targetId) return undefined;

  return uuid.startsWith(OVERLAY_PREF) && !targetId.startsWith(OVERLAY_PREF)
    ? `${OVERLAY_PREF}${targetId}`
    : targetId;
};

export const findColIdByTag = (
  cols: Record<string, any> | undefined,
  tag: string,
  sourceUuid: string,
) => {
  const targetId = Object.entries(cols ?? {}).find(
    ([, col]) => col?.tag === tag,
  )?.[0];

  return getOverlayTargetId(sourceUuid, targetId);
};
